import styled from 'styled-components';

import { SkeletonLoader } from '@pkg/components/SkeletonLoader';

export const CarouselSkeleton = styled(SkeletonLoader)`
    width: 186px;
    height: 200px;
    border-radius: 10px;
`;

export const CarouselImage = styled.img`
    display: flex;
    object-fit: cover;
    justify-content: center;
    align-items: center;
    width: 186px;
    height: 200px;
`;

export const CarouselWrapper = styled.div`
    position: relative;
    width: 186px;
    height: 200px;
    filter: drop-shadow(0 0 22.6667px rgba(0, 0, 0, 0.55));
    border-radius: 10px;
    overflow: hidden;

    .slick-list,
    .slick-slider,
    .slick-track {
        position: relative;
        display: block;
    }
    .slick-loading .slick-slide,
    .slick-loading .slick-track {
        visibility: hidden;
    }
    .slick-slider {
        box-sizing: border-box;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
        -khtml-user-select: none;
        -ms-touch-action: pan-y;
        touch-action: pan-y;
        -webkit-tap-highlight-color: transparent;
    }
    .slick-list {
        overflow: hidden;
        margin: 0;
        padding: 0;
    }
    .slick-list:focus {
        outline: 0;
    }
    .slick-list.dragging {
        cursor: pointer;
        cursor: hand;
    }
    .slick-slider .slick-list,
    .slick-slider .slick-track {
        -webkit-transform: translate3d(0, 0, 0);
        -moz-transform: translate3d(0, 0, 0);
        -ms-transform: translate3d(0, 0, 0);
        -o-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }
    .slick-track {
        top: 0;
        left: 0;
    }
    .slick-track:after,
    .slick-track:before {
        display: table;
        content: '';
    }
    .slick-track:after {
        clear: both;
    }
    .slick-slide {
        display: none;
        float: left;
        height: 100%;
        min-height: 1px;
    }
    [dir='rtl'] .slick-slide {
        float: right;
    }
    .slick-slide img {
        display: block;
    }
    .slick-slide.slick-loading img {
        display: none;
    }
    .slick-slide.dragging img {
        pointer-events: none;
    }
    .slick-initialized .slick-slide {
        display: block;
    }
    .slick-vertical .slick-slide {
        display: block;
        height: auto;
        border: 1px solid transparent;
    }
    .slick-arrow.slick-hidden {
        display: none;
    }
    .slick-dots,
    .slick-next,
    .slick-prev {
        position: absolute;
        display: block;
        padding: 0;
    }
    .slick-next,
    .slick-prev {
        font-size: 0;
        line-height: 0;
        top: 0%;
        width: 20px;
        height: 100%;
        cursor: pointer;
        color: transparent;
        border: none;
        outline: 0;
        background: transparent;
        z-index: 1;
    }
    .slick-next:focus,
    .slick-next:hover,
    .slick-prev:focus,
    .slick-prev:hover {
        color: transparent;
        outline: 0;
        background: 0 0;
    }
    .slick-next:focus:before,
    .slick-next:hover:before,
    .slick-prev:focus:before,
    .slick-prev:hover:before {
        opacity: 1;
    }
    .slick-next.slick-disabled:before,
    .slick-prev.slick-disabled:before {
        opacity: 0.25;
    }
    .slick-next:before,
    .slick-prev:before {
        font-size: 20px;
        line-height: 1;
        opacity: 0.75;
        color: #fff;
    }
    .slick-prev {
        left: 0;
    }
    [dir='rtl'] .slick-prev {
        right: 0;
        left: auto;
    }
    .slick-next {
        right: 0;
    }
    [dir='rtl'] .slick-next {
        right: auto;
        left: 0;
    }
    .slick-dotted.slick-slider {
        margin-bottom: 30px;
    }
    .slick-dots {
        bottom: 0;
        height: 60px;
        width: 100%;
        margin: 0;
        list-style: none;
        text-align: center;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.8), transparent);
        display: flex !important;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 15px;
    }
    .slick-dots li {
        position: relative;
        display: inline-block;
        width: 7px;
        height: 7px;
        margin: 0 3px;
        padding: 0;
        cursor: pointer;
        background: rgba(255, 255, 255, 0.4);
        border-radius: 50%;
    }
    .slick-dots li button {
        font-size: 0;
        line-height: 0;
        display: block;
        width: 7px;
        height: 7px;
        cursor: pointer;
        color: transparent;
        border-radius: 50%;
        border: 0;
        outline: 0;
        background: 0 0;
    }
    .slick-dots li button:focus,
    .slick-dots li button:hover {
        outline: 0;
    }
    .slick-dots li button:focus:before,
    .slick-dots li button:hover:before {
        opacity: 1;
    }

    .slick-dots li.slick-active {
        background: rgba(255, 255, 255, 1);
    }
`;
